import { render, staticRenderFns } from "./LiveGatewayDisplay.vue?vue&type=template&id=45147140&scoped=true&"
import script from "./LiveGatewayDisplay.vue?vue&type=script&lang=js&"
export * from "./LiveGatewayDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LiveGatewayDisplay.vue?vue&type=style&index=0&id=45147140&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45147140",
  null
  
)

export default component.exports